(function () {
  'use strict';

  if (window.SellmerBundleBuilder) return;

  function routes() {
    return (window.theme && window.theme.routes) || {};
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    var locale = (window.theme && window.theme.language) || document.documentElement.lang || 'de-DE';
    var currency = document.documentElement.getAttribute('data-currency') || 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
  }

  function parseLocalizedPriceCents(text) {
    var matches = String(text || '').match(/\d[\d\s.,]*/g);
    if (!matches || !matches.length) return 0;

    var value = matches[matches.length - 1].replace(/\s/g, '');
    var comma = value.lastIndexOf(',');
    var dot = value.lastIndexOf('.');
    var separator = comma > dot ? ',' : '.';
    var separatorIndex = value.lastIndexOf(separator);

    if (separatorIndex !== -1 && value.length - separatorIndex - 1 <= 2) {
      var whole = value.slice(0, separatorIndex).replace(/[.,]/g, '');
      var decimals = value.slice(separatorIndex + 1).replace(/[.,]/g, '');
      value = whole + '.' + decimals;
    } else {
      value = value.replace(/[.,]/g, '');
    }

    var amount = Number(value);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function uniqueBundleId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'bundle-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function storePendingBundle(pending) {
    var value = JSON.stringify(pending);
    window.localStorage.setItem('sellmer_pending_bundle', value);
    window.sessionStorage.setItem('sellmer_pending_bundle', value);
  }

  function clearPendingBundle() {
    window.localStorage.removeItem('sellmer_pending_bundle');
    window.sessionStorage.removeItem('sellmer_pending_bundle');
  }

  function storedBundleDiscountCodes() {
    try {
      var raw = window.localStorage.getItem('sellmer_bundle_discount_codes');
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function saveBundleDiscountCodes(codes) {
    window.localStorage.setItem('sellmer_bundle_discount_codes', JSON.stringify(codes || {}));
  }

  function activeAppBundleIds(cart) {
    var ids = [];
    (cart && cart.items || []).forEach(function (item) {
      var id = item && item.properties ? String(item.properties._app_bundle_id || '') : '';
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function pruneBundleDiscountCodes(cart) {
    var activeIds = activeAppBundleIds(cart);
    var stored = storedBundleDiscountCodes();
    var pruned = {};

    activeIds.forEach(function (id) {
      if (stored[id]) pruned[id] = stored[id];
    });
    saveBundleDiscountCodes(pruned);
    return pruned;
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) { window.setTimeout(resolve, milliseconds); });
  }

  function waitFor(test, timeout) {
    var started = Date.now();

    return new Promise(function (resolve, reject) {
      function check() {
        var result = test();
        if (result) {
          resolve(result);
          return;
        }
        if (Date.now() - started >= timeout) {
          reject(new Error('Die Bundle-App konnte nicht vollständig geladen werden. Bitte laden Sie die Seite neu.'));
          return;
        }
        window.setTimeout(check, 100);
      }
      check();
    });
  }

  function productSection(builder) {
    return builder.closest('section[data-product-id]') || document;
  }

  function appProductButtonVariantId(button) {
    if (!button) return '';

    var directId = String(button.dataset.variantId || '');
    if (directId) return directId;

    var productCard = button.closest('.child-product-card[data-variant-id]');
    var cardId = productCard ? String(productCard.dataset.variantId || '') : '';
    if (cardId) return cardId;

    var values = button.closest('.child-card-values') || button.parentElement;
    var variantInput = values && values.querySelector(
      '.bundle-varint-id, .bundle-variant-id, #pageBundleChildVariantId'
    );

    return variantInput ? String(variantInput.value || '') : '';
  }

  function appProductButtonInRoot(root, variantId) {
    var expectedId = String(variantId || '');
    if (!root || !expectedId) return null;

    return Array.prototype.find.call(
      root.querySelectorAll('.page-bundle-add-item-btn'),
      function (button) {
        return appProductButtonVariantId(button) === expectedId;
      }
    ) || null;
  }

  function appContext(builder) {
    var section = productSection(builder);
    var checkoutButtons = Array.prototype.slice.call(
      section.querySelectorAll('#pageBundleCheckoutButton[data-bundle-id]')
    );

    if (!checkoutButtons.length && section !== document) {
      checkoutButtons = Array.prototype.slice.call(
        document.querySelectorAll('#pageBundleCheckoutButton[data-bundle-id]')
      );
    }
    if (!checkoutButtons.length) return null;

    var variantIds = builderVariantIds(builder);
    var checkout = checkoutButtons.find(function (candidate) {
      var root = candidate.closest('.shopify-app-block, [id^="shopify-block-"]') || candidate.parentElement;
      return root && variantIds.length > 0 && variantIds.every(function (variantId) {
        return appProductButtonInRoot(root, variantId);
      });
    }) || checkoutButtons[0];

    var appBlock = checkout.closest('.shopify-app-block, [id^="shopify-block-"]') || checkout.parentElement;
    var appBundleId = String(checkout.dataset.bundleId || '');
    if (appBundleId) builder.dataset.appBundleId = appBundleId;

    return { root: appBlock, checkout: checkout, bundleId: appBundleId };
  }

  function appSelectedVariantIds(builder) {
    var ids = [];
    var context = appContext(builder);
    var root = context && context.root ? context.root : productSection(builder);
    root.querySelectorAll('.selected-prod-img [data-variant-id]').forEach(function (element) {
      var id = String(element.dataset.variantId || '');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function appProductButton(builder, variantId) {
    var context = appContext(builder);
    var root = context && context.root ? context.root : productSection(builder);
    return appProductButtonInRoot(root, variantId);
  }

  function appCheckoutButton(builder) {
    var context = appContext(builder);
    return context ? context.checkout : null;
  }

  function appFixedPriceCents(builder) {
    var context = appContext(builder);
    var appCard = context && context.root ? context.root.querySelector('#pageBundleCard') : null;
    if (!appCard || appCard.dataset.discountType !== 'fixed_price') return 0;

    var offer = context.root.querySelector('.page-offer-text');
    return offer ? parseLocalizedPriceCents(offer.textContent) : 0;
  }

  function builderVariantIds(builder) {
    var ids = [];
    builder.querySelectorAll('[data-bundle-select] option[value]').forEach(function (option) {
      var id = String(option.value || '');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function hideBridgedApp(builder) {
    var checkout = appCheckoutButton(builder);
    var variantIds = builderVariantIds(builder);
    var productsReady = variantIds.length > 0 && variantIds.every(function (id) {
      return appProductButton(builder, id);
    });
    if (!checkout || !productsReady) return false;

    var appBlock = checkout.closest('.shopify-app-block, [id^="shopify-block-"]');
    if (appBlock) appBlock.classList.add('sellmer-bundle-app-bridge');
    return true;
  }

  function revealBridgedApp(builder) {
    var checkout = appCheckoutButton(builder);
    if (!checkout) return;

    var appBlock = checkout.closest('.shopify-app-block, [id^="shopify-block-"]');
    if (appBlock) appBlock.classList.remove('sellmer-bundle-app-bridge');
    window.dispatchEvent(new Event('resize'));
  }

  function syncAppSelections(builder, options) {
    var desired = options.map(function (option) { return String(option.value); });

    revealBridgedApp(builder);

    return wait(300).then(function () {
      return waitFor(function () {
        return desired.every(function (id) { return appProductButton(builder, id); }) && appCheckoutButton(builder);
      }, 15000);
    }).then(function () {
      var sequence = Promise.resolve();

      appSelectedVariantIds(builder).forEach(function (id) {
        if (desired.indexOf(id) !== -1) return;
        sequence = sequence.then(function () {
          var button = appProductButton(builder, id);
          if (!button) return;
          button.click();
          return waitFor(function () { return appSelectedVariantIds(builder).indexOf(id) === -1; }, 5000);
        });
      });

      desired.forEach(function (id) {
        sequence = sequence.then(function () {
          if (appSelectedVariantIds(builder).indexOf(id) !== -1) return;
          var button = appProductButton(builder, id);
          if (!button) throw new Error('Ein ausgewähltes Motiv ist in der Bundle-App nicht verfügbar.');
          button.click();
          return waitFor(function () { return appSelectedVariantIds(builder).indexOf(id) !== -1; }, 5000);
        });
      });

      return sequence.then(function () {
        var selected = appSelectedVariantIds(builder);
        if (selected.length !== desired.length || !desired.every(function (id) { return selected.indexOf(id) !== -1; })) {
          throw new Error('Die Motivauswahl konnte nicht vollständig an die Bundle-App übertragen werden.');
        }
        hideBridgedApp(builder);
      });
    });
  }

  function selectedOption(select) {
    return select && select.value ? select.options[select.selectedIndex] : null;
  }

  function getPicker(builder) {
    return builder && builder._bundlePicker ? builder._bundlePicker : null;
  }

  function updateTrigger(select) {
    var selector = select.closest('.bundle-builder__selector');
    if (!selector) return;

    var option = selectedOption(select);
    var trigger = selector.querySelector('[data-bundle-trigger]');
    var image = selector.querySelector('[data-bundle-trigger-image]');
    var placeholder = selector.querySelector('.bundle-builder__trigger-placeholder');
    var title = selector.querySelector('[data-bundle-trigger-title]');
    var price = selector.querySelector('[data-bundle-trigger-price]');
    if (!trigger || !image || !placeholder || !title || !price) return;

    if (option) {
      title.textContent = option.dataset.productTitle || option.textContent.trim();
      price.textContent = formatMoney(Number(option.dataset.price || 0));
      price.hidden = false;
      trigger.classList.add('is-selected');

      if (option.dataset.image) {
        image.src = option.dataset.image;
        image.alt = option.dataset.productTitle || '';
        image.hidden = false;
        placeholder.hidden = true;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
        placeholder.hidden = false;
      }
    } else {
      var builder = select.closest('[data-bundle-builder]');
      title.textContent = (builder && builder.dataset.placeholder) || 'Motiv auswählen';
      price.textContent = '';
      price.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      image.hidden = true;
      placeholder.hidden = false;
      trigger.classList.remove('is-selected');
    }
  }

  function updateGallery(builder, selects) {
    var gallery = document.querySelector('[data-bundle-gallery="' + builder.dataset.sectionId + '"]');
    if (!gallery) return;

    selects.forEach(function (select, index) {
      var slot = gallery.querySelector('[data-bundle-gallery-slot="' + index + '"]');
      if (!slot) return;

      var option = selectedOption(select);
      var image = slot.querySelector('[data-bundle-gallery-image]');
      var placeholder = slot.querySelector('[data-bundle-gallery-placeholder]');
      var caption = slot.querySelector('.bundle-gallery__caption');

      if (option && option.dataset.image) {
        image.src = option.dataset.image;
        image.alt = option.dataset.productTitle || '';
        image.classList.remove('hidden');
        placeholder.classList.add('hidden');
        caption.textContent = option.dataset.productTitle || '';
      } else {
        var selector = select.closest('.bundle-builder__selector');
        var label = selector && selector.querySelector('.bundle-builder__selector-label');
        image.removeAttribute('src');
        image.alt = '';
        image.classList.add('hidden');
        placeholder.classList.remove('hidden');
        caption.textContent = label ? label.textContent.trim() : 'Kalender ' + (index + 1);
      }
    });
  }

  function updateDistinctOptions(selects, requireDistinct) {
    var selectedProducts = selects.map(function (select) {
      var option = selectedOption(select);
      return option ? option.dataset.productId : '';
    });

    selects.forEach(function (select, selectIndex) {
      Array.prototype.forEach.call(select.options, function (option) {
        if (!option.value) return;
        var usedElsewhere = requireDistinct && selectedProducts.some(function (productId, index) {
          return index !== selectIndex && productId && productId === option.dataset.productId;
        });
        option.disabled = option.hasAttribute('data-unavailable') || usedElsewhere;
      });
    });
  }

  function updatePickerChoices(builder, select) {
    var picker = getPicker(builder);
    if (!picker || !select) return;

    var selects = Array.prototype.slice.call(builder.querySelectorAll('[data-bundle-select]'));
    var activeIndex = selects.indexOf(select);
    var requireDistinct = builder.dataset.requireDistinct === 'true';
    var selectedProducts = selects.map(function (item) {
      var option = selectedOption(item);
      return option ? option.dataset.productId : '';
    });

    picker.querySelectorAll('[data-bundle-choice]').forEach(function (choice) {
      var unavailable = choice.hasAttribute('data-unavailable');
      var usedElsewhere = requireDistinct && selectedProducts.some(function (productId, index) {
        return index !== activeIndex && productId && productId === choice.dataset.productId;
      });
      choice.disabled = unavailable || usedElsewhere;
      choice.classList.toggle('is-selected', String(choice.dataset.variantId) === String(select.value));
      choice.classList.toggle('is-used', usedElsewhere);
      choice.setAttribute('aria-pressed', String(choice.dataset.variantId) === String(select.value) ? 'true' : 'false');
      var usedLabel = choice.querySelector('[data-bundle-choice-used]');
      if (usedLabel) usedLabel.hidden = !usedElsewhere;
    });
  }

  function openPicker(builder, trigger) {
    var picker = getPicker(builder);
    var panel = picker && picker.querySelector('[data-bundle-picker-panel]');
    var grid = picker && picker.querySelector('.bundle-picker__grid');
    var title = picker && picker.querySelector('[data-bundle-picker-title]');
    var select = builder.querySelector('[data-bundle-select][data-slot-index="' + trigger.dataset.slotIndex + '"]');
    if (!picker || !panel || !select) return;

    builder._bundleActiveSelect = select;
    builder._bundleReturnFocus = trigger;
    if (title) {
      var label = trigger.closest('.bundle-builder__selector').querySelector('.bundle-builder__selector-label');
      title.textContent = (label ? label.textContent.trim() + ': ' : '') + (builder.dataset.placeholder || 'Motiv auswählen');
    }
    updatePickerChoices(builder, select);
    window.clearTimeout(builder._bundleCloseTimer);
    trigger.setAttribute('aria-expanded', 'true');
    if (grid) grid.scrollTop = 0;
    picker.hidden = false;
    document.body.classList.add('bundle-picker-open');
    window.requestAnimationFrame(function () {
      picker.classList.add('is-open');
      var selected = picker.querySelector('[data-bundle-choice].is-selected:not([disabled])');
      if (selected) {
        selected.focus({ preventScroll: true });
        selected.scrollIntoView({ block: 'nearest' });
      } else {
        panel.focus({ preventScroll: true });
        if (grid) grid.scrollTop = 0;
      }
    });
  }

  function closePicker(builder) {
    var picker = getPicker(builder);
    if (!picker || picker.hidden) return;

    picker.classList.remove('is-open');
    document.body.classList.remove('bundle-picker-open');
    builder._bundleCloseTimer = window.setTimeout(function () { picker.hidden = true; }, 180);
    if (builder._bundleReturnFocus) {
      builder._bundleReturnFocus.setAttribute('aria-expanded', 'false');
      builder._bundleReturnFocus.focus();
    }
    builder._bundleActiveSelect = null;
    builder._bundleReturnFocus = null;
  }

  function chooseProduct(builder, choice) {
    var select = builder._bundleActiveSelect;
    if (!select || choice.disabled) return;

    select.value = choice.dataset.variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closePicker(builder);
  }

  function updateBuilder(builder) {
    var selects = Array.prototype.slice.call(builder.querySelectorAll('[data-bundle-select]'));
    var requireDistinct = builder.dataset.requireDistinct === 'true';
    var options = selects.map(selectedOption).filter(Boolean);
    var complete = options.length === Number(builder.dataset.bundleSize);
    var productIds = options.map(function (option) { return option.dataset.productId; });
    var distinct = !requireDistinct || new Set(productIds).size === productIds.length;
    var original = options.reduce(function (total, option) { return total + Number(option.dataset.price || 0); }, 0);
    var discount = Number(builder.dataset.discountPercent || 0);
    var calculatedTotal = original - Math.round(original * discount / 100);
    var appFixedPrice = appFixedPriceCents(builder);
    var parentPrice = Number(builder.dataset.bundleParentPrice || 0);
    var total = appFixedPrice > 0 ? appFixedPrice : (parentPrice > 0 ? parentPrice : calculatedTotal);
    var saving = Math.max(0, original - total);

    updateDistinctOptions(selects, requireDistinct);
    selects.forEach(updateTrigger);
    updateGallery(builder, selects);

    var prices = builder.querySelector('[data-bundle-prices]');
    if (prices) {
      prices.hidden = options.length === 0;
      builder.querySelector('[data-bundle-original-price]').textContent = formatMoney(original);
      builder.querySelector('[data-bundle-savings]').textContent = '-' + formatMoney(saving);
      builder.querySelector('[data-bundle-total]').textContent = formatMoney(total);
    }

    var button = builder.querySelector('[data-bundle-add]');
    if (button) button.disabled = !(complete && distinct);
  }

  function removeAddedBundleItems(addedItems) {
    var updates = {};
    (addedItems || []).forEach(function (item) {
      if (item && item.key) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve();

    return fetch((routes().cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).catch(function () {
      return null;
    });
  }

  function preparedAppDetails(options, appBundleId) {
    var cartItems = [];
    var discountItems = [];

    options.forEach(function (option) {
      var variantId = String(option.value || '');
      var productId = String(option.dataset.productId || '');
      var productName = option.dataset.productTitle || option.textContent.trim();
      var quantity = '1';

      if (!variantId || !productId) {
        throw new Error('Ein ausgewähltes Motiv enthält keine vollständigen Shopify-Produktdaten.');
      }

      cartItems.push({
        id: variantId,
        quantity: Number(quantity),
        product_name: productName,
        properties: {
          '_page_bundle_id': String(appBundleId),
          '_essenifyBundles:OfferId': String(appBundleId),
          '_essenifyBundles:prodQty': quantity
        }
      });
      discountItems.push({
        product_id: productId,
        bundle_id: String(appBundleId),
        variant_id: variantId,
        quantity: quantity,
        product_name: productName
      });
    });

    return { cartItems: cartItems, discountItems: discountItems };
  }

  function preparedSingleBundleLine(options, appBundleId, parentVariantId, bundle) {
    var selections = [];
    var originalTotal = options.reduce(function (sum, option) {
      return sum + Number(option.dataset.price || 0);
    }, 0);
    var savings = Math.max(0, originalTotal - Number(bundle.price || 0));
    var properties = {
      '_essenify_byb_main_line': 'true',
      '_page_bundle_id': String(appBundleId),
      '_bundle_id': bundle.id,
      '_app_bundle_id': String(appBundleId),
      '_bundle_name': bundle.name,
      '_bundle_size': String(bundle.size),
      '_bundle_original_total_cents': String(originalTotal),
      '_bundle_savings_cents': String(savings)
    };

    options.forEach(function (option, index) {
      var variantId = String(option.value || '');
      var productId = String(option.dataset.productId || '');
      var productName = option.dataset.productTitle || option.textContent.trim();

      if (!variantId || !productId) {
        throw new Error('Ein ausgewähltes Motiv enthält keine vollständigen Shopify-Produktdaten.');
      }

      selections.push({
        product_id: productId,
        variant_id: variantId,
        quantity: '1'
      });

      // Essenify uses visible product-name properties for its bundle summary.
      // Our private motif properties keep the order stable in the custom cart.
      properties[productName] = 'x1';
      properties['_bundle_motif_' + String(index + 1)] = productName;
    });

    properties._essenify_build_box_items = JSON.stringify(selections);

    return {
      id: Number(parentVariantId),
      quantity: 1,
      properties: properties
    };
  }

  function addSingleAppBundleAndOpenCart(cartItem, appBundleId, bundleId) {
    window.localStorage.setItem('bundle_id', String(appBundleId));
    window.localStorage.setItem('bundle_type', 'page_bundle');

    return fetch((routes().cart_add_url || '/cart/add') + '.js?ignorecheck=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [cartItem] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (body) {
            throw new Error(body.description || body.message || 'Das Bundle konnte nicht hinzugefügt werden.');
          });
        }
        return response.json();
      })
      .then(function (result) {
        var addedItems = result && Array.isArray(result.items) ? result.items : [];
        var added = addedItems.some(function (item) {
          return item && item.properties && String(item.properties._bundle_id || '') === String(bundleId);
        });
        if (!added) throw new Error('Shopify hat das Bundle nicht bestätigt. Bitte versuchen Sie es erneut.');
        clearPendingBundle();
        window.location.assign(routes().cart_url || '/cart');
      });
  }

  function applyBundleDiscountCodes(codes) {
    var uniqueCodes = [];
    (codes || []).forEach(function (code) {
      code = String(code || '').trim();
      if (code && uniqueCodes.indexOf(code) === -1) uniqueCodes.push(code);
    });

    return fetch((routes().cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: uniqueCodes.join(',') })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (body) {
          throw new Error(body.description || body.message || 'Die Bundle-Rabatte konnten nicht angewendet werden.');
        });
      }
      return response.json();
    });
  }

  function bundleItemsAreDiscounted(cart) {
    var bundleItems = (cart && cart.items || []).filter(function (item) {
      return item && item.properties && item.properties._bundle_id;
    });
    if (!bundleItems.length) return false;

    return bundleItems.every(function (item) {
      var originalPrice = Number(item.original_price || item.original_line_price || 0);
      var finalPrice = Number(item.final_price || item.discounted_price || item.final_line_price || item.line_price || 0);
      var allocations = item.line_level_discount_allocations || [];
      return allocations.length > 0 || (originalPrice > 0 && finalPrice < originalPrice);
    });
  }

  function bundleDiscountUrl(appBundleId) {
    var bundleHostUrl = window.bundleHost || '/apps/bundle-host';
    var endpoint = window.bundleDispoint || '/api/bundle_theme/:bundle_theme_id/discount_request';
    var encodedId = encodeURIComponent(String(appBundleId));

    endpoint = endpoint.replace(':bundle_theme_id', encodedId);
    endpoint = endpoint.replace(/(\/bundle_theme\/)[^/]+(\/discount_request)/, '$1' + encodedId + '$2');
    return bundleHostUrl + endpoint;
  }

  function addAppBundleAndOpenCart(cartItems, discountItems, appBundleId) {
    var addedItems = [];
    var previousCodes = storedBundleDiscountCodes();
    var shopDomain = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    var discountUrl = bundleDiscountUrl(appBundleId) + '?shop_domain=' + encodeURIComponent(shopDomain);

    window.localStorage.setItem('bundle_id', String(appBundleId));
    window.localStorage.setItem('bundle_type', 'page_bundle');

    return fetch((routes().cart_add_url || '/cart/add') + '.js?ignorecheck=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (body) {
            throw new Error(body.description || body.message || 'Die Bundle-Artikel konnten nicht hinzugefügt werden.');
          });
        }
        return response.json();
      })
      .then(function (result) {
        addedItems = result && Array.isArray(result.items) ? result.items : [];
        return fetch(discountUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            data: {
              prod_id_arr: discountItems,
              bundle_id: String(appBundleId),
              customer_id: window.customerId || null,
              bundle_type: 'page_bundle'
            }
          })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Der Bundle-Rabatt konnte nicht erstellt werden.');
        return response.json();
      })
      .then(function (discountResponse) {
        var code = discountResponse && discountResponse.code;
        if (!code) throw new Error('Die Bundle-App hat keinen Rabattcode zurückgegeben.');
        if (typeof window.setCookie === 'function') window.setCookie('pageBundleCode', code);

        var nextCodes = Object.assign({}, previousCodes);
        nextCodes[String(appBundleId)] = String(code);
        return applyBundleDiscountCodes(Object.keys(nextCodes).map(function (id) { return nextCodes[id]; }))
          .then(function (cart) {
            if (!bundleItemsAreDiscounted(cart)) {
              throw new Error('Die Bundle-Rabatte konnten nicht sicher kombiniert werden. Der Warenkorb wurde nicht verändert.');
            }
            saveBundleDiscountCodes(nextCodes);
            window.location.assign(routes().cart_url || '/cart');
          });
      })
      .catch(function (error) {
        return removeAddedBundleItems(addedItems)
          .then(function () {
            clearPendingBundle();
            var codes = Object.keys(previousCodes).map(function (id) { return previousCodes[id]; });
            return applyBundleDiscountCodes(codes).catch(function () { return null; });
          })
          .then(function () { throw error; });
      });
  }

  function addBundle(builder) {
    var button = builder.querySelector('[data-bundle-add]');
    var message = builder.querySelector('[data-bundle-message]');
    var options = Array.prototype.slice.call(builder.querySelectorAll('[data-bundle-select]')).map(selectedOption);
    var bundleId = uniqueBundleId();
    var bundleName = builder.dataset.bundleName || 'Bundle';
    var bundleSize = builder.dataset.bundleSize || String(options.length);
    var parentVariantId = Number(builder.dataset.bundleParentVariantId || 0);
    var parentPrice = Number(builder.dataset.bundleParentPrice || 0);
    var appBundleId = String(builder.dataset.appBundleId || '').trim();

    if (options.some(function (option) { return !option; })) return;
    if (!/^\d+$/.test(appBundleId)) {
      message.textContent = 'Das Bundle ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.';
      message.classList.add('is-error');
      return;
    }
    if (!parentVariantId) {
      message.textContent = 'Das Bundle-Hauptprodukt ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.';
      message.classList.add('is-error');
      return;
    }
    if (options.some(function (option) { return !(option.dataset.sku || '').trim(); })) {
      message.textContent = 'Mindestens ein ausgewähltes Motiv hat keine SKU. Bitte hinterlegen Sie die SKU in Shopify, bevor das Bundle verkauft wird.';
      message.classList.add('is-error');
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.textContent = 'Bundle wird in den Warenkorb gelegt …';
    message.classList.remove('is-error');

    Promise.resolve()
      .then(function () {
        return fetch((routes().cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || body.message); });
        return response.json();
      })
      .then(function (cart) {
        var selectedVariantIds = options.map(function (option) { return Number(option.value); });
        var selectedProductAlreadyInCart = cart.items.some(function (item) {
          return selectedVariantIds.indexOf(Number(item.variant_id)) !== -1;
        });
        if (selectedProductAlreadyInCart) {
          throw new Error('Mindestens eines der ausgewählten Motive liegt bereits einzeln im Warenkorb. Bitte entfernen Sie es dort und versuchen Sie es erneut.');
        }
        pruneBundleDiscountCodes(cart);
      })
      .then(function () {
        var pending = {
          parentVariantId: parentVariantId,
          appBundleId: appBundleId,
          bundleId: bundleId,
          bundleName: bundleName,
          bundleSize: bundleSize,
          items: options.map(function (option) {
            return {
              variantId: Number(option.value),
              title: option.dataset.productTitle || option.textContent.trim(),
              sku: option.dataset.sku || ''
            };
          })
        };
        storePendingBundle(pending);

        /*
         * Both app bundles now use "Show each item individually". Send the
         * selected child variants and let Essenify create the fixed-price
         * discount code. The app has enabled both codes to combine in one cart.
         */
        var appDetails = preparedAppDetails(options, appBundleId);
        var cartItems = appDetails.cartItems;
        var discountItems = appDetails.discountItems;
        var expectedIds = pending.items.map(function (item) { return Number(item.variantId); });
        var originalTotal = options.reduce(function (sum, option) {
          return sum + Number(option.dataset.price || 0);
        }, 0);
        var savings = Math.max(0, originalTotal - parentPrice);

        cartItems.forEach(function (item) {
          var position = expectedIds.indexOf(Number(item.id));
          item.properties = Object.assign({}, item.properties || {}, {
            '_bundle_id': pending.bundleId,
            '_app_bundle_id': pending.appBundleId,
            '_bundle_name': pending.bundleName,
            '_bundle_component': 'true',
            '_bundle_position': String(position + 1),
            '_bundle_original_total_cents': String(originalTotal),
            '_bundle_savings_cents': String(savings)
          });
        });

        message.textContent = 'Bundle und Rabatt werden vorbereitet …';
        return addAppBundleAndOpenCart(cartItems, discountItems, appBundleId);
      })
      .catch(function (error) {
        hideBridgedApp(builder);
        message.textContent = error.message || 'Das Bundle konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.';
        message.classList.add('is-error');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  function pendingBundle() {
    try {
      var raw = window.localStorage.getItem('sellmer_pending_bundle') || window.sessionStorage.getItem('sellmer_pending_bundle');
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      clearPendingBundle();
      return null;
    }
  }

  function enrichPendingBundle() {
    var pending = pendingBundle();
    if (!pending || !Array.isArray(pending.items) || !pending.items.length) return Promise.resolve(false);

    return fetch((routes().cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Der Warenkorb konnte nicht gelesen werden.');
        return response.json();
      })
      .then(function (cart) {
        var taggedItems = cart.items.filter(function (cartItem) {
          return cartItem.properties && cartItem.properties._bundle_id === pending.bundleId;
        });
        if (taggedItems.length === pending.items.length) {
          clearPendingBundle();
          return false;
        }

        var claimedKeys = {};
        var componentItems = pending.items.map(function (selectedItem) {
          var match = cart.items.find(function (cartItem) {
            return !claimedKeys[cartItem.key] &&
              Number(cartItem.variant_id) === Number(selectedItem.variantId) &&
              !(cartItem.properties && cartItem.properties._bundle_id);
          });
          if (match) claimedKeys[match.key] = true;
          return match;
        });

        if (componentItems.some(function (item) { return !item; })) return false;

        return componentItems.reduce(function (request, item, index) {
          return request.then(function () {
            var properties = Object.assign({}, item.properties || {}, {
              '_bundle_id': pending.bundleId,
              '_app_bundle_id': pending.appBundleId,
              '_bundle_name': pending.bundleName,
              '_bundle_component': 'true',
              '_bundle_position': String(index + 1)
            });
            return fetch((routes().cart_change_url || '/cart/change') + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
            }).then(function (response) {
              if (!response.ok) throw new Error('Die Bundle-Artikel konnten nicht gruppiert werden.');
            });
          });
        }, Promise.resolve()).then(function () {
          clearPendingBundle();
          return true;
        });
      });
  }

  function initBuilder(builder) {
    if (builder.dataset.bundleInitialized === 'true') return;
    builder.dataset.bundleInitialized = 'true';
    var picker = builder.querySelector('[data-bundle-picker]');
    if (picker) {
      var duplicate = document.body.querySelector('#' + picker.id);
      if (duplicate && duplicate !== picker) duplicate.remove();
      builder._bundlePicker = picker;
      document.body.appendChild(picker);
    }
    builder.addEventListener('change', function (event) {
      if (event.target.matches('[data-bundle-select]')) updateBuilder(builder);
    });
    builder.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bundle-trigger]');
      if (trigger) {
        openPicker(builder, trigger);
        return;
      }

    });
    if (picker) {
      picker.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-bundle-choice]');
        if (choice) {
          chooseProduct(builder, choice);
          return;
        }
        if (event.target.closest('[data-bundle-picker-close]')) closePicker(builder);
      });
      picker.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closePicker(builder);
          return;
        }

        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(
          picker.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) {
          return element.offsetParent !== null;
        });
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
    var button = builder.querySelector('[data-bundle-add]');
    if (button) button.addEventListener('click', function () { addBundle(builder); });
    updateBuilder(builder);

    if (hideBridgedApp(builder)) {
      updateBuilder(builder);
    } else {
      var observer = new MutationObserver(function () {
        if (hideBridgedApp(builder)) {
          updateBuilder(builder);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { observer.disconnect(); }, 30000);
    }
  }

  function decorateCart(root) {
    (root || document).querySelectorAll('[data-cart-items]').forEach(function (container) {
      var seen = {};
      container.querySelectorAll('[data-bundle-id]').forEach(function (item) {
        var id = item.dataset.bundleId;
        item.dataset.bundleFirst = seen[id] ? 'false' : 'true';
        seen[id] = true;
      });
    });
  }

  function removeBundle(button) {
    var firstItem = button.closest('[data-bundle-id]');
    var container = button.closest('[data-cart-items]');
    if (!firstItem || !container) return;

    var id = firstItem.dataset.bundleId;
    var updates = {};
    container.querySelectorAll('[data-bundle-id]').forEach(function (item) {
      if (item.dataset.bundleId === id) updates[item.dataset.cartItem] = 0;
    });

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch((routes().cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Bundle konnte nicht entfernt werden.');
        return response.json();
      })
      .then(function (cart) {
        var remainingCodes = pruneBundleDiscountCodes(cart);
        if (!Object.keys(remainingCodes).length) return cart;
        return applyBundleDiscountCodes(Object.keys(remainingCodes).map(function (appBundleId) {
          return remainingCodes[appBundleId];
        }));
      })
      .then(function () {
        if (window.Cart && typeof window.Cart.update === 'function') {
          window.Cart.update();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bundle-builder]').forEach(initBuilder);
    decorateCart(root || document);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bundle-remove]');
    if (button) removeBundle(button);
  });
  document.addEventListener('cartItems', function () { window.setTimeout(function () { decorateCart(document); }, 0); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var builder = event.target.querySelector('[data-bundle-builder]');
    if (builder && builder._bundlePicker) builder._bundlePicker.remove();
    document.body.classList.remove('bundle-picker-open');
  });
  var pageInitialized = false;

  function initializePage() {
    if (pageInitialized) return;
    pageInitialized = true;

    enrichPendingBundle()
      .then(function (changed) {
        if (changed) window.location.reload();
      })
      .catch(function (error) {
        window.console.error('Bundle-Daten konnten nicht ergänzt werden:', error);
      });
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage);
  } else {
    initializePage();
  }
  window.addEventListener('pageshow', initializePage);

  window.SellmerBundleBuilder = { init: init, decorateCart: decorateCart };
})();

